// extracted by extract-css-chunks-webpack-plugin
module.exports = {"banner_box":"banner_box-h8XvWMG6","banner":"banner-2WYFylxd"};